import React, { useState } from "react";
import "./faq.css";
import ScrollReveal from "../scrollReveal/scrollReveal";

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const faqData = [
    {
      question: "What is AgentRAI?",
      answer:
        "AgentRAI is an advanced platform designed to enhance AI trust, quality, and risk management while ensuring ethical AI operations with robust guardrails.",
    },
    {
      question: "How does AgentRAI calculate the AI Trust Score?",
      answer:
        "AgentRAI leverages real-time monitoring, transparency metrics, and performance analytics to generate a trust score that evaluates the reliability and integrity of AI systems, based on the data and models used in their development.",
    },
    {
      question: "What industries can benefit from AgentRAI?",
      answer:
        "AgentRAI is versatile and serves industries like Financial Services, Healthcare, Retail, Manufacturing, and Telecommunications, among others.",
    },
    {
      question: "How does AgentRAI help in managing AI risks?",
      answer:
        "AgentRAI proactively identifies potential risks, monitors system vulnerabilities, and provides actionable insights to mitigate risks before they impact performance.",
    },
    {
      question: "What role do AI guardrails play in AgentRAI?",
      answer:
        "AI guardrails enforce ethical and operational boundaries, ensuring that AI operates securely, responsibly, and in alignment with compliance standards.",
    },
    {
      question: "Does AgentRAI support compliance with regulations?",
      answer:
        "Absolutely. AgentRAI automates audits and regulatory checks, simplifying compliance processes and reducing associated costs.",
    },
    {
      question: "How does AgentRAI improve AI quality?",
      answer:
        "AgentRAI ensures consistent and superior AI performance by monitoring, analyzing, and optimizing quality metrics across all operations.",
    },
    {
      question:
        "What makes AgentRAI different from other AI management solutions?",
      answer:
        "AgentRAI stands out with its unique combination of trust scoring, quality assurance, risk management, and ethical guardrails, offering a comprehensive solution for trusted and reliable AI.",
    },
  ];

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <ScrollReveal>
      <section className="first-accordion" id="five">
        <div className="container">
          <div className="section-wrapper">
            <div className="section-heading">
              <div className="heading-tag">
                <span>FAQ</span>
              </div>
              <h2>AI Assurance FAQs: Guide to Common Queries</h2>
            </div>
            <div className="accordion">
              {faqData.map((item, index) => (
                <div className="accordion-item" key={index}>
                  <button
                    id={`accordion-button-${index + 1}`}
                    aria-expanded={activeIndex === index ? "true" : "false"}
                    onClick={() => toggleAccordion(index)}
                  >
                    <span className="accordion-title">{item.question}</span>
                    <span className="icon" aria-hidden="true"></span>
                  </button>
                  <div className="accordion-content">
                    <p>{item.answer}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </ScrollReveal>
  );
};

export default FAQ;
